import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { ContactFormGroup } from './model/contact-form-group';
import { Contact } from './model/contact';

@Injectable({
  providedIn: 'root',
})
export class ContactIntakeUtilsService {
  static readonly defaultInterest = 'bjj';
  static readonly defaultLevel = 'beginner';
  static readonly defaultGroup = 'erwachsene';
  static readonly defaultFormSettings: Partial<Contact> = {
    interest: ContactIntakeUtilsService.defaultInterest,
    level: ContactIntakeUtilsService.defaultLevel,
    group: ContactIntakeUtilsService.defaultGroup,
  };

  static createFormGroup(): FormGroup<ContactFormGroup> {
    return new FormGroup<ContactFormGroup>({
      firstname: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(100)],
        nonNullable: true,
      }),
      lastname: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(100)],
        nonNullable: true,
      }),
      zip: new FormControl('', {
        validators: [Validators.maxLength(5)],
      }),
      address: new FormControl('', {
        validators: [Validators.maxLength(100)],
      }),
      phone: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(25)],
        nonNullable: true,
      }),
      email: new FormControl('', {
        validators: [Validators.required, Validators.email, Validators.maxLength(100)],
        nonNullable: true,
      }),
      interest: new FormControl(ContactIntakeUtilsService.defaultInterest),
      level: new FormControl(ContactIntakeUtilsService.defaultLevel),
      group: new FormControl(ContactIntakeUtilsService.defaultGroup),
      message: new FormControl('', {
        validators: [Validators.maxLength(5000)],
      }),
    });
  }

  public static touchAll(formGroup: UntypedFormGroup | UntypedFormArray): void {
    Object.keys(formGroup.controls).forEach((key: string) => {
      const controls = formGroup.controls as { [key: string]: AbstractControl };
      const abstractControl = controls[key];
      if (abstractControl instanceof UntypedFormGroup || abstractControl instanceof UntypedFormArray) {
        this.touchAll(abstractControl);
      } else {
        abstractControl.markAsTouched();
      }
    });
  }
}
